import React, { useCallback } from "react";
import { useCustomPromo } from "components/CustomPromo/hooks";
import CustomPromoBanner from "components/CustomPromo/CustomPromoBanner/CustomPromoBanner";
import { isPromoValid } from "components/CustomPromo/promoValidation";
import ClientOnly from "components/ClientOnly";
import MaybeCustomPromoModal from "components/CustomPromo/CustomPromoModal/MaybeCustomPromoModal";
import { msg, t } from "@lingui/core/macro";
import { LanguageCode } from "src/utils/localization/languages/types";

type Props = {
  languageCode: LanguageCode;
};
const CustomPromo: React.FC<Props> = ({ languageCode }) => {
  const { promoState, updatePromoState } = useCustomPromo();

  const handleModalClose = useCallback(() => {
    updatePromoState({ showCustomPromoModal: false });
  }, [updatePromoState]);

  const handleBannerClick = useCallback(() => {
    updatePromoState({ showCustomPromoModal: true });
  }, [updatePromoState]);

  return (
    <>
      <CustomPromoBanner
        isVisible={isPromoValid(promoState.promoCode)}
        onClick={handleBannerClick}
      />
      <ClientOnly>
        <MaybeCustomPromoModal
          title={t(msg`YOUR EXCLUSIVE BENEFIT`)}
          isPromoValid={isPromoValid(promoState.promoCode)}
          onRequestClose={handleModalClose}
          isShowable={promoState.showCustomPromoModal}
          languageCode={languageCode}
        />
      </ClientOnly>
    </>
  );
};

export default CustomPromo;
